const ITEMS = [
  "FREE BRAND AUDIT",
  "₹999 GROWTH CALL",
  "STRATEGY",
  "WEBSITES",
  "FUNNELS",
  "CONTENT",
  "EXECUTION",
  "REAL RESULTS",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-strip" className="relative border-y border-[#27331C] bg-[#0E140A] py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-display text-xl sm:text-2xl text-[#8A8C7E] whitespace-nowrap">
                <span className="px-6">{item}</span>
                <span className="text-[var(--accent)] text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
